app.controller("AgreementsIndexController", ["$scope", "$stateParams", "Students", "$uibModal", "$state", "AgreementService", "usSpinnerService",
    function ($scope, $stateParams, Students, $uibModal, $state, AgreementService, usSpinnerService) {
        $scope.agreements = null;
        $scope.totalItems = 0;
        $scope.itemsPerPage = 10;
        $scope.title = $stateParams.title;
        $scope.fromDate = $stateParams.fromDate;
        $scope.toDate = $stateParams.toDate;

        $scope.popup1 = {
            opened: false
        };

        $scope.popup2 = {
            opened: false
        };

        $scope.openFromDate = function () {
            $scope.popup1.opened = true;
        };

        $scope.openToDate = function () {
            $scope.popup2.opened = true;
        };

        loadPage($stateParams.page, $scope.title, $scope.fromDate, $scope.toDate, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.open = function (agreement) {
            $uibModal.open({
                controller: "AgreementsWindowController",
                templateUrl: _pb + 'agreements/agreement-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {agreement: agreement};
                    }
                }
            }).result
                .then(function (result) {

                }, function () {

                });
        };

        function loadPage(page, query, fromDate, toDate, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            AgreementService.sendList({
                page: page,
                query: query,
                fromDate: fromDate,
                toDate: toDate,
                limit: $scope.itemsPerPage
            }).then(function (data) {
                $scope.agreements = data;
                $scope.totalItems = data.length;
                usSpinnerService.stop("root");
                cb();
            });
        }

        $scope.create = function () {
            $state.go("admin.createAgreement", {});
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.title,
                fromDate: $scope.fromDate,
                toDate: $scope.toDate
            });
        };
    }
]);
